
export interface ICollection<T> {
  items: T[];

  /**
   * This function will append items to the collection, with the
   * optional parameter to replace them if the desire is to perform
   * an update on an existing record in the collection.
   */
  add: (item: T, pos?: number) => T[];

  /**
   * Match is used when you are trying to compare contents
   * of an entity for uniqueness, this allows locating an item
   * that doesn't share a memory reference but has identical
   * contents
   */
  match: (item: T) => number | undefined;

  /**
   * Locate this item in the collection by memory reference
   * you must be looking for an item you previously retrieved
   * from the collection or previously added to the collection
   */
  find: (item: T) => T | undefined;

  /**
   * Locate and remove an item by memory reference.  Similar to
   * the `find` method this will only locate a record if using
   * the same variable reference you retrieved or added to the
   * collection previously.  If looking for a content match, use
   * `match`
   */
  remove: (item: T) => number;
}

export function Collection<T>(initial: T[]): ICollection<T> {
  const items: T[] = [...initial];

  const add = (item: T, pos?: number): T[] => {
    if (pos !== undefined && items[pos]) {
      items[pos] = item;
    } else {
      items.push(item);
    }
    return items;
  };

  const match = (item: T): number | undefined => {
    for (let x = 0; x < items.length; x++) {
      if (JSON.stringify(item) === JSON.stringify(items[x])) {
        return x;
      }
    }
    return undefined;
  };

  const find = (item: T) => {
    const pos = items.indexOf(item);
    if (pos >= 0) {
      return items[pos];
    }
  };

  const remove = (item: T) => {
    const pos = items.indexOf(item);
    if (pos >= 0) {
      items.splice(pos, 1);
    }
    return pos;
  };

  return { items, add, find, remove, match };
}